import { createDate, importAll, transformImages } from "utils";

import AcceptanceLetterMain from "../../_hp-acceptance-letter-main";
import ReplicaContent from "components/Replicas/ReplicaContent";
import ReplicaParagraph from "components/Replicas/ReplicaParagraph";
import ReplicaQuote from "components/Replicas/ReplicaQuote";
import { ReplicaVersionType } from "types";
import background from "./background.jpg";
import thumbnail from "./thumbnail.png";

let gallery = [];

try {
  gallery = importAll(
    (require as any).context("./gallery", false, /\.(png|jpe?g|svg)$/)
  );
} catch (e) {
  console.log(e);
}

/* VERSION DATA */
export const VERSION_DATA: ReplicaVersionType = {
  isWIP: false,
  page: undefined,
  dateCreated: createDate({ day: 1, month: 5, year: 2025 }),
  datePublished: createDate({ day: 1, month: 7, year: 2025 }),
  version: "1",
  isSeries: false,
  thumbnail,
  background,
};

/* VERSION PAGE */
const Page = () => {
  return (
    <ReplicaContent>
      <ReplicaQuote source="Harry Potter and the Chamber of Secrets">
        Fred brought the car lower and Harry saw a dark patchwork of fields and
        clumps of trees. ‘We’re a little way outside the village,’ said George.
        ‘Ottery St Catchpole ...’ Lower and lower went the flying car. The edge
        of a brilliant red sun was now gleaming through the trees.
      </ReplicaQuote>
      {/* <ReplicaQuote source="Harry Potter and the Chamber of Secrets">
        Harry sat down and took the toast Mrs Weasley offered him. ‘Letters from
        school,’ said Mr Weasley, passing Harry and Ron identical envelopes of
        yellowish parchment, addressed in green ink. ‘Dumbledore already knows
        you’re here, Harry – doesn’t miss a trick, that man. You two’ve got
        them, too,’ he added, as Fred and George ambled in, still in their
        pyjamas.
      </ReplicaQuote> */}

      <ReplicaParagraph>
        A fully readable, authentic replica of Ron Weasley’s Hogwarts acceptance
        letter. This letter is not only never featured in the films, but also
        never mentioned in the books either. However, since Ron was accepted to
        Hogwarts, it seems reasonable to assume he did in fact receive his own
        acceptance letter - just like Harry did in the first book. As we briefly
        see the main characters receiving their letters in the second film, I
        was able to find a reference image of Ron’s letter (or more precisely,
        the envelope), and used that as the basis for this replica. Unlike
        Harry, Ron’s address doesn’t really change, which made the design
        process more straightforward.
      </ReplicaParagraph>

      <AcceptanceLetterMain gallery={transformImages(gallery)} />
    </ReplicaContent>
  );
};

export default {
  ...VERSION_DATA,
  page: <Page />,
} as ReplicaVersionType;
